export const SEAT_SELECTION_TITLE = "Seat Selection";
export const CONTINUE_CTA_TEXT = "Continue";

export const SEAT_SELECTION_VALIDATION_MESSAGE =
  "Select your seats or skip seat selection to continue.";
